import React, { useState, useEffect } from 'react';
import '../Login/Modal.css';
import './UserFormModal.css';

const UserFormModal = ({ show, onClose, onSubmit, user, isEdit }) => {
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    password: '',
    confirmPassword: '',
    role: 'sales',
    isActive: true,
    email: '',
    lineId: ''
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (user && isEdit) {
      setFormData({
        name: user.name,
        username: user.username,
        password: '',
        confirmPassword: '',
        role: user.role,
        isActive: user.isActive,
        email: user.email || '',
        lineId: user.lineId || ''
      });
    } else {
      setFormData({
        name: '',
        username: '',
        password: '',
        confirmPassword: '',
        role: 'sales',
        isActive: true,
        email: '',
        lineId: ''
      });
    }
    setErrors({});
  }, [user, isEdit, show]);

  const validate = () => {
    const newErrors = {};
    const usernameRegex = /^[a-zA-Z0-9_]+$/;
    if (!formData.name.trim()) newErrors.name = '請輸入姓名';
    if (!formData.username.trim()) {
      newErrors.username = '請輸入帳號';
    } else if (formData.username.length < 3 || formData.username.length > 30) {
      newErrors.username = '帳號長度須為 3–30 字元';
    } else if (!usernameRegex.test(formData.username)) {
      newErrors.username = '帳號只能包含英文字母、數字、底線';
    }
    if (!isEdit && !formData.password) newErrors.password = '請輸入密碼';
    if (!isEdit && formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = '密碼不一致';
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    onSubmit(formData);
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEdit ? '編輯用戶' : '新增用戶'}</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-row">
              <div className="form-group">
                <label>姓名 *</label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
              </div>
              <div className="form-group">
                <label>帳號 *</label>
                <input
                  type="text"
                  className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                  value={formData.username}
                  onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                  disabled={isEdit}
                  placeholder="例如：wang_manager"
                />
                {errors.username && <div className="invalid-feedback">{errors.username}</div>}
              </div>
            </div>

            {!isEdit && (
              <div className="form-row">
                <div className="form-group">
                  <label>密碼 *</label>
                  <input
                    type="password"
                    className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  />
                  {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                </div>
                <div className="form-group">
                  <label>確認密碼 *</label>
                  <input
                    type="password"
                    className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                  />
                  {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                </div>
              </div>
            )}

            <div className="form-row">
              <div className="form-group">
                <label>角色 *</label>
                <select
                  className="form-control"
                  value={formData.role}
                  onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                >
                  <option value="manager">主管</option>
                  <option value="purchasing">採購</option>
                  <option value="sales">業務</option>
                </select>
              </div>
              <div className="form-group">
                <label>狀態</label>
                <select
                  className="form-control"
                  value={formData.isActive}
                  onChange={(e) => setFormData({ ...formData, isActive: e.target.value === 'true' })}
                >
                  <option value="true">啟用</option>
                  <option value="false">停用</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>E-mail</label>
                <input
                  type="email"
                  className="form-control"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="例如：celine@hunge.com.tw"
                />
              </div>
              <div className="form-group">
                <label>通訊方式</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.lineId}
                  onChange={(e) => setFormData({ ...formData, lineId: e.target.value })}
                  placeholder="例如：LINE celine.chen"
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              {isEdit ? '更新' : '建立帳號'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserFormModal;
